import script from "./NavBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavBar.vue?vue&type=script&setup=true&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=2546ae73&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2546ae73"]])

export default __exports__